import { useState } from 'react';
import { useAuth } from '../lib/auth.jsx';
import { t } from '../lib/i18n.js';
import { Alert, Input } from '../components/ui.jsx';

export default function Login() {
  const { signIn } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(username.trim(), password);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page" style={{ maxWidth: 420, paddingTop: '8vh' }}>
      <div className="login-brand">
        {/* The full logo is on white paper, so it sits on its own card and reads
            the same way in the light and dark themes. */}
        <img src="/logo.png" alt={t.app.name} width="240" />
      </div>
      <p className="muted small center">{t.app.signInPrompt}</p>

      <form className="card" onSubmit={submit}>
        <div className="card-body">
          {error && <Alert tone="error">{error}</Alert>}
          <Input
            label={t.auth.username}
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            dir="ltr"
            autoFocus
          />
          <Input
            label={t.auth.password}
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            dir="ltr"
          />
          <button type="submit" className="btn btn-primary btn-block" disabled={busy || !username || !password}>
            {busy ? <span className="spinner" /> : t.auth.signIn}
          </button>
        </div>
      </form>
    </div>
  );
}
